// DiagnosisTimeModal.jsx

import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  VStack,
  FormControl,
  FormLabel,
  Select,
  Button,
  Flex,
  Text,
  useToast,
  Spinner,
  IconButton,
} from "@chakra-ui/react";
import { HamburgerIcon, CloseIcon, DeleteIcon } from '@chakra-ui/icons';
import axios from "axios";
import TimeRangeWidget from "../TimeRangeWidget";
import moment from "moment";
import DatePickerLabel from "../DatePickerLabel";
import { server } from "../../util/connect";
import { FaRemoveFormat } from "react-icons/fa";
import { mapDayToThai } from "../../util/calendar_util";

const DiagnosisTimeModal = ({
  isOpen,
  onClose,
  selectedTimeSlot,
  doctorId,
  operation,
  fetchDoctorData
}) => {
  const [day, setDay] = useState("Monday");
  const [startHour, setStartHour] = useState("");
  const [startMinute, setStartMinute] = useState("");
  const [endHour, setEndHour] = useState("");
  const [endMinute, setEndMinute] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);

  const toast = useToast();
  const dateArr = [
    { key: "เลือกวันออกตรวจ", value: "" },
    { key: "จันทร์", value: "Monday" },
    { key: "อังคาร", value: "Tuesday" },
    { key: "พุธ", value: "Wednesday" },
    { key: "พฤหัสบดี", value: "Thursday" },
    { key: "ศุกร์", value: "Friday" },
    { key: "เสาร์", value: "Saturday" },
    { key: "อาทิตย์", value: "Sunday" },
  ];

  useEffect(() => {
    if (selectedTimeSlot && operation == "edit") {
      const sh = moment(selectedTimeSlot.start_time, "HH:mm:ss").format(
        "HH"
      );
      const sm = moment(selectedTimeSlot.start_time, "HH:mm:ss").format(
        "mm"
      );
      const eh = moment(selectedTimeSlot.end_time, "HH:mm:ss").format("HH");
      const em = moment(selectedTimeSlot.end_time, "HH:mm:ss").format("mm");

      setDay(selectedTimeSlot.day || "Monday");
      setStartHour(sh || "");
      setStartMinute(sm || "");
      setEndHour(eh || "");
      setEndMinute(em || "");

      const sd = selectedTimeSlot.start_date
        ? moment(selectedTimeSlot.start_date).format("YYYY-MM-DD")
        : "";
      setStartDate(sd);

      const ed = selectedTimeSlot.end_date
        ? moment(selectedTimeSlot.end_date).format("YYYY-MM-DD")
        : "";
      setEndDate(ed);

      if (selectedTimeSlot) {
        console.log(sh + ":" + sm);
      }
    } else {
      setStartHour("");
      setStartMinute("");
      setEndHour("");
      setEndMinute("");
      setDay("")
      setStartDate("")
      setEndDate("")
      setStartTime("")
      setEndTime("")
    }
  }, [selectedTimeSlot, operation]);

  const isStartTimeBeforeEndTime = (startTime, endTime) => {
    if (startTime === null || startTime === undefined || startTime === "") {
      return false;
    }
    if (endTime === null || endTime === undefined || endTime === "") {
      return false;
    }

    const startParts = startTime.split(":");
    const endParts = endTime.split(":");

    const startHours = parseInt(startParts[0], 10);
    const startMinutes = parseInt(startParts[1], 10);
    const endHours = parseInt(endParts[0], 10);
    const endMinutes = parseInt(endParts[1], 10);

    if (
      startHours < endHours ||
      (startHours === endHours && startMinutes < endMinutes)
    ) {
      return true;
    } else {
      return false;
    }
  };

  const handleSave = async () => {
    console.log(`startTime: ${startTime}`)
    console.log(`endTime: ${endTime}`)

    if(!day){
      toast({title: "คุณยังไม่ได้เลือกวันออกตรวจ", status: "warning", duration: 3000, isClosable: true,});
    }
    else if (!isStartTimeBeforeEndTime(startTime, endTime)) {
      toast({title: "เวลาไม่ถูกต้อง", status: "warning", duration: 3000, isClosable: true,});
    }
    else if (!startDate){
      toast({title: "คุณยังไม่ได้ระบุวันที่เริ่มออกตรวจ", status: "warning", duration: 3000, isClosable: true,});
    }
    else{
      try {
        setIsProcessing(true)
        const response = await axios.post(`${server}/timetable/save_doctor_timetable`, {
          day,
          doctor_id: doctorId,
          start_time: startTime,
          end_time: endTime,
          end_hour: endHour,
          end_minute: endMinute,
          start_date: startDate,
          end_date: endDate,
          diagnosis_time_id: selectedTimeSlot ? selectedTimeSlot.id : "",
        });

        console.log("response.status: "+response.status)
        setIsProcessing(false)
        if (response.status === 200 || response.status === 201) {
          if(response.data.status == "success"){
            toast({title: "บันทึกเรียบร้อย", status: "success", duration: 3000, isClosable: true,});
            fetchDoctorData();
            onClose();
          }
          else{
            toast({title: `วันเริ่มกับวันสิ้นสุดซ้ำกับข้อมูลของวัน '${mapDayToThai(day)}' ก่อนหน้า`, status: "warning", duration: 3000, isClosable: true,});
          }
        }
        else{
          toast({title: "ไม่สามารถบันทึกข้อมูลได้", status: "error", duration: 3000, isClosable: true,});
        }

        
      } catch (error) {
        toast({title: "ไม่สามารถบันทึกข้อมูลได้", status: "error", duration: 3000, isClosable: true,});
        setIsProcessing(false)
        console.error(error);
      }
    }
    
  };

  const setStartDay = (val) => {
    setStartDate(val);
  };

  const setEndDay = (val) => {
    setEndDate(val);
  };

  const clearEndDate = () => {
    setEndDate("")
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          {selectedTimeSlot ? "แก้ไข" : "เพิ่ม"}เวลาออกตรวจ
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={4}>
            <FormControl>
              <FormLabel>วันที่ออกตรวจ</FormLabel>
              <Select value={day} onChange={(e) => setDay(e.target.value)}>
                {dateArr.map((e) => (
                  <option key={e.key} value={e.value}>
                    {e.key}
                  </option>
                ))}
              </Select>
            </FormControl>
            <FormControl>
              <FormLabel>เวลาออกตรวจ</FormLabel>
              <TimeRangeWidget
                //resetTime={isOpen}
                sHour={startHour}
                sMinute={startMinute}
                eHour={endHour}
                eMinute={endMinute}
                setStartTime={setStartTime}
                setEndTime={setEndTime}
              />
            </FormControl>
            <FormControl>
              <FormLabel>วันที่เริ่มตรวจ</FormLabel>
              <DatePickerLabel
                setSelectedDay={setStartDay}
                initDateStr={startDate}
              />
            </FormControl>
            <FormControl>
              <FormLabel>วันที่สิ้นสุด</FormLabel>
              <Flex>
                <DatePickerLabel
                  setSelectedDay={setEndDay}
                  initDateStr={endDate}
                />
                {endDate && <IconButton ml={2} icon={<DeleteIcon/>} size={'md'} color="black" bgColor="white" onClick={clearEndDate} />}
              </Flex>
            </FormControl>
            <Text fontSize={12} color={"gray.400"}>
              <b>คำเตือน:</b> กรณีที่ต้องการเปลี่ยนแปลงวันที่ออกตรวจใหม่ ให้ทำการเพิ่มรายการตรวจของวันนั้นๆ ใหม่
            </Text>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button isDisabled={isProcessing} colorScheme="blue" mr={3} onClick={handleSave}>
            บันทึก <Spinner display={isProcessing?"flex":"none"} size={"sm"} ml={1} />
          </Button>
          <Button onClick={onClose}>ยกเลิก</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DiagnosisTimeModal;
